import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=78fd54ed&scoped=true"
import script from "./FieldLabel.vue?vue&type=script&lang=js"
export * from "./FieldLabel.vue?vue&type=script&lang=js"
import style0 from "./FieldLabel.vue?vue&type=style&index=0&id=78fd54ed&prod&scoped=true&lang=css"
import style1 from "./FieldLabel.vue?vue&type=style&index=1&id=78fd54ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd54ed",
  null
  
)

export default component.exports